/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from 'react';
import { Link } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import slugify from '../../utils/slugify';
import Services from '../../data/services';
import Button from '../../elements/Button';
import BgImage from '../../assets/images/hero/services.png';

export default function ServicesPage() {
  return (
    <>
      <section className="py-20 lg:py-28 bg-premium-light">
        <div className="container mx-auto px-6">
          <Fade direction="up" triggerOnce>
            <div className="text-center mb-4">
              <span className="inline-block px-4 py-1.5 rounded-full bg-brand-green-50 text-brand-green-600 text-sm font-semibold tracking-wide uppercase mb-4">
                What We Offer
              </span>
            </div>
            <h1 className="text-4xl lg:text-5xl font-extrabold text-surface-900 mb-6 text-center tracking-tight">Our Services</h1>
          </Fade>

          <Fade delay={100} direction="up" triggerOnce>
            <p className="text-surface-300 text-lg mb-16 max-w-2xl mx-auto text-center">
              Professional IT solutions crafted to support your business growth and stability.
            </p>
          </Fade>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {Services.map((serviceName, index) => {
              const slug = slugify(serviceName);
              const img = `/hero/services/${slug}.jpg`;

              return (
                <Fade key={serviceName} direction="up" delay={100 * (index + 1)} triggerOnce>
                  <Link to={`/services/${slug}`} className="block group h-full">
                    <div className="glass-card flex flex-col overflow-hidden h-[100%] min-h-[380px]">
                      {img ? (
                        <div className="w-full h-48 relative overflow-hidden flex-shrink-0">
                          <img src={img} alt={serviceName} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                        </div>
                      ) : (
                        <div className="w-full h-48 flex-shrink-0 flex items-center justify-center bg-surface-900/5 backdrop-blur-sm">
                           <svg className="w-16 h-16 text-brand-green-500/50" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                           </svg>
                        </div>
                      )}
                      <div className="p-6 flex flex-col flex-1">
                        <h2 className="text-xl font-bold text-surface-900 mb-3">
                          {serviceName}
                        </h2>
                        <p className="text-surface-300 text-sm flex-1 leading-relaxed">
                          Learn more about our {serviceName.toLowerCase()} offering and how it supports your business.
                        </p>
                        <span className="mt-4 text-brand-green-500 font-semibold text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                          Learn more
                          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </Link>
                </Fade>
              );
            })}
          </div>
        </div>
      </section>

      <Fade direction="up" triggerOnce>
        <section className="w-full flex justify-center px-4 sm:px-10">
          <div className="relative w-full max-w-[1600px] rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={BgImage}
              alt="Discuss background"
              className="absolute inset-0 w-full h-full object-cover object-right transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-surface-900/80 via-surface-900/60 to-surface-900/30" />
            <div className="relative z-10 bg-transparent py-14 sm:py-20 px-6 sm:px-12 lg:px-16 min-h-[420px]">
              <div className="max-w-5xl mx-auto">
                <div className="flex flex-col sm:flex-row sm:items-center mb-6 sm:mb-10">
                  <h2 className="w-full sm:w-2/3 text-4xl sm:text-5xl lg:text-6xl leading-tight font-semibold text-white">
                    An IT Partner That Makes Your Life Easier.
                  </h2>
                  <div className="mt-6 sm:mt-0 sm:ml-4 lg:ml-8">
                    <Button
                      href="/contact"
                      type="link"
                      className="btn-premium text-base sm:text-lg px-8 py-4"
                    >
                      Contact Us Today!
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </Button>
                  </div>
                </div>
                <p className="font-light text-lg sm:text-xl lg:text-2xl text-white/80 max-w-3xl leading-relaxed">
                  Whether you&apos;re overwhelmed with the day-to-day IT tasks that slow you down, or if you&apos;re looking for a team to execute an IT project you&apos;re unsure how to start, we work together with our clients to provide IT services and support that makes a difference to your business&apos; growth. DNS Computer provides Managed IT Services and Technology Consulting for businesses from coast to coast.
                </p>
              </div>
            </div>
          </div>
        </section>
      </Fade>
    </>
  );
}
